import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

export default function Home() {
  const [videos, setVideos] = useState([]);

  const API_KEY = "AIzaSyCCmau8ly1-aNuSKgqxYBY5a1ppSlaMudU"; // tu clave
  const PLAYLIST_ID = "PL3YujFO-c_HE2ZlhccbuP6DVLuI2BpZh_"; // tu playlist
  const MAX_RESULTS = 30;

  useEffect(() => {
    const fetchVideos = async () => {
      try {
        const res = await fetch(
          `https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&playlistId=${PLAYLIST_ID}&maxResults=${MAX_RESULTS}&key=${API_KEY}`
        );
        const data = await res.json();
        if (data.items) {
          const videosFormatted = data.items.map((item) => ({
            videoId: item.snippet.resourceId.videoId,
            snippet: item.snippet,
          }));
          setVideos(videosFormatted);
        } else {
          console.error("No se encontraron videos:", data);
        }
      } catch (error) {
        console.error("Error al obtener videos:", error);
      }
    };

    fetchVideos();
  }, []);

  return (
    <main className="flex flex-col gap-6 p-6 text-white bg-gray-900 min-h-screen">
      {/* Sección de presentación */}
      <section className="flex flex-col sm:flex-row items-center gap-6 bg-gray-800 rounded-2xl p-6 shadow-2xl max-w-4xl mx-auto transform transition-all hover:scale-105">
        {/* Foto ovalada */}
        <div className="flex-shrink-0">
          <img
            src="/mi-foto.png"
            alt="Foto personal"
            className="w-32 h-32 sm:w-36 sm:h-36 rounded-full object-cover border-4 border-white shadow-lg"
          />
        </div>

        {/* Texto centrado y moderno */}
        <div className="text-center sm:text-left flex-1">
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-2 drop-shadow-md">
            Domingo Del Rosario
          </h2>
          <p className="text-white/90 text-sm sm:text-base leading-relaxed mb-4">
            Informático y piloto comercial de profesión, apasionado por los negocios y el trading.
            <br />
            Después de operar varios mercados me enfoqué exclusivamente en los <strong>futuros del Nasdaq 100</strong>.
            <br />
            En esta página encontrarás mis operaciones diarias, mi diario de trading y acceso a un curso completamente <strong>gratis</strong>, diseñado para guiar a quienes quieren entrar en este apasionante mundo.
            <br />
            <span className="text-blue-300 font-semibold">¡Bienvenidos!</span>
          </p>

          <Link
            to="/curso"
            className="inline-block mt-2 px-6 py-2 bg-white text-gray-900 font-semibold rounded-full shadow-lg hover:bg-blue-500 hover:text-white transition-colors"
          >
            Ver mi curso
          </Link>
        </div>
      </section>

      {/* Descripción superior */}
      <section className="text-center max-w-3xl mx-auto">
        <h1 className="text-2xl font-semibold mb-2 text-gray-200">
          "La dura y fría realidad del trading es que cada operación tiene un resultado incierto"
          <br />
          <span className="text-gray-400 text-lg">— Mark Douglas</span>
        </h1>
      </section>

      {/* Galería de videos */}
      <section className="flex flex-col gap-6 mt-4 max-w-7xl mx-auto w-full">
        <div className="bg-gray-800 rounded-lg shadow-lg overflow-hidden p-6">
          <h2 className="text-2xl font-semibold text-gray-200 mb-6 text-center">
            Videos de mis ultimas entradas.
          </h2>

          {videos.length === 0 ? (
            <p className="text-center text-gray-400">Cargando videos...</p>
          ) : (
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
              {videos.map((video, index) => (
                <a
                  key={index}
                  href={`https://www.youtube.com/watch?v=${video.videoId}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group block relative rounded-lg overflow-hidden"
                >
                  <img
                    src={video.snippet.thumbnails.medium.url}
                    alt={video.snippet.title}
                    className="w-full rounded-lg transition-transform duration-300 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-black bg-opacity-30 opacity-0 group-hover:opacity-100 flex items-center justify-center transition-opacity duration-300">
                    <span className="text-white text-sm font-medium">Ver en YouTube</span>
                  </div>
                </a>
              ))}
            </div>
          )}
        </div>
      </section>
    </main>
  );
}
